export const designTokens = {
  colors: {
    '--gray5': '#f4f4f4',
    '--gray10': '#e9e9e9',
    '--gray15': '#dfdfdf',
    '--gray20': '#d2d2d2',
    '--gray25': '#c5c5c5',
    '--gray30': '#b6b6b6',
    '--gray35': '#a8a8a8',
    '--gray40': '#9a9a9a',
    '--gray45': '#8e8e8e',
    '--gray50': '#818181',
    '--gray55': '#767676',
    '--gray60': '#696969',
    '--gray65': '#5e5e5e',
    '--gray70': '#525252',
    '--gray75': '#474747',
    '--gray80': '#3b3b3b',
    '--gray85': '#303030',
    '--gray90': '#262626',
    '--gray95': '#1b1b1b',
    '--gray100': '#121212',
    '--red5': '#fff0f3',
    '--red10': '#ffe0e7',
    '--red15': '#ffd4dc',
    '--red20': '#ffc2ce',
    '--red25': '#ffb0c0',
    '--red30': '#ff99ac',
    '--red35': '#fc8397',
    '--red40': '#f76d84',
    '--red45': '#ed5c75',
    '--red50': '#e04c65',
    '--red55': '#d43f58',
    '--red60': '#c42d49',
    '--red65': '#b51f3f',
    '--red70': '#a31035',
    '--red75': '#8f0b2e',
    '--red80': '#780b26',
    '--red85': '#630920',
    '--red90': '#4f0918',
    '--red95': '#380912',
    '--red100': '#26070d',
    '--magenta5': '#fff0f9',
    '--magenta10': '#ffe3f4',
    '--magenta15': '#fcd4ec',
    '--magenta20': '#fcc2e5',
    '--magenta25': '#faafdc',
    '--magenta30': '#fa96d2',
    '--magenta35': '#f582c7',
    '--magenta40': '#f069ba',
    '--magenta45': '#eb54af',
    '--magenta50': '#e03fa0',
    '--magenta55': '#d43192',
    '--magenta60': '#c2217f',
    '--magenta65': '#b50e72',
    '--magenta70': '#a30564',
    '--magenta75': '#8c0855',
    '--magenta80': '#750647',
    '--magenta85': '#5e0b3c',
    '--magenta90': '#4a0c30',
    '--magenta95': '#330d23',
    '--magenta100': '#210a18',
    '--purple5': '#f8f2ff',
    '--purple10': '#f3e6ff',
    '--purple15': '#ead9fa',
    '--purple20': '#e2cafa',
    '--purple25': '#d7baf7',
    '--purple30': '#cba7f2',
    '--purple35': '#c198ed',
    '--purple40': '#b687e8',
    '--purple45': '#ac76e3',
    '--purple50': '#9f67d6',
    '--purple55': '#945ccc',
    '--purple60': '#854dbd',
    '--purple65': '#7a43b0',
    '--purple70': '#6c37a1',
    '--purple75': '#5f2d91',
    '--purple80': '#50237d',
    '--purple85': '#431b69',
    '--purple90': '#351752',
    '--purple95': '#261238',
    '--purple100': '#1a0d24',
    '--blue5': '#e6f7ff',
    '--blue10': '#d1f1ff',
    '--blue15': '#b0e5ff',
    '--blue20': '#8adaff',
    '--blue25': '#5fcefa',
    '--blue30': '#41c1f0',
    '--blue35': '#29b3e6',
    '--blue40': '#16a5d9',
    '--blue45': '#009ace',
    '--blue50': '#008ec2',
    '--blue55': '#0080b2',
    '--blue60': '#0072a3',
    '--blue65': '#006796',
    '--blue70': '#005780',
    '--blue75': '#004b70',
    '--blue80': '#003f5e',
    '--blue85': '#00334d',
    '--blue90': '#00283d',
    '--blue95': '#021e2e',
    '--blue100': '#02141f',
    '--green5': '#dcfce8',
    '--green10': '#c6f5d6',
    '--green15': '#b2edc8',
    '--green20': '#9ae3b5',
    '--green25': '#85d6a3',
    '--green30': '#6bc98d',
    '--green35': '#4dbd78',
    '--green40': '#2eb066',
    '--green45': '#17a358',
    '--green50': '#00964e',
    '--green55': '#008744',
    '--green60': '#007a3d',
    '--green65': '#006e37',
    '--green70': '#006131',
    '--green75': '#005229',
    '--green80': '#004523',
    '--green85': '#00381c',
    '--green90': '#002e18',
    '--green95': '#002111',
    '--green100': '#00170c',
    '--coldGray5': '#f2f3f5',
    '--coldGray10': '#e8eaed',
    '--coldGray15': '#dee0e3',
    '--coldGray20': '#d0d2d6',
    '--coldGray25': '#c3c5ca',
    '--coldGray30': '#b4b6ba',
    '--coldGray35': '#a6a8ad',
    '--coldGray40': '#989a9e',
    '--coldGray45': '#8d8f94',
    '--coldGray50': '#808287',
    '--coldGray55': '#74767b',
    '--coldGray60': '#67696d',
    '--coldGray65': '#5c5e63',
    '--coldGray70': '#515357',
    '--coldGray75': '#46474b',
    '--coldGray80': '#3a3b3f',
    '--coldGray85': '#2f3034',
    '--coldGray90': '#25262a',
    '--coldGray95': '#1a1b1e',
    '--coldGray100': '#121315',

    '--orange5': '#FFF2E3',
    '--orange15': '#F7DAC8',
    '--orange85': '#412A03',
    '--orange95': '#271901',
  },
  light: {
    '--backgroundSubtle00': '#f4f4f4',
    '--backgroundSubtle01': '#ffffff',
    '--backgroundSubtle02': '#f4f4f4',
    '--backgroundAccent': '#dfdfdf',
    '--backgroundInverse': '#262626',
    '--backgroundInteractive': '#009ace',
    '--backgroundDestructive': '#d43f58',
    '--backgroundOverlay': 'rgba(0, 0, 0, 0.630)',
    '--borderSubtle': 'rgba(0, 0, 0, 0.085)',
    '--borderAccent': 'rgba(0, 0, 0, 0.228)',
    '--borderInteractive': '#009ace',
    '--borderError': '#d43f58',
    '--borderOnColorSubtle': 'rgba(255, 255, 255, 0.085)',
    '--borderOnColorAccent': 'rgba(255, 255, 255, 0.230)',
    '--borderWarning': '#fa8e41',
    '--borderSuccess': '#00964e',
    '--textPrimary': 'rgba(0, 0, 0, 0.930)',
    '--textSecondary': 'rgba(0, 0, 0, 0.630)',
    '--textTertiary': 'rgba(0, 0, 0, 0.445)',
    '--textInverse': '#ffffff',
    '--textOnColorPrimary': '#ffffff',
    '--textOnColorSecondary': 'rgba(255, 255, 255, 0.772)',
    '--textOnColorTertiary': 'rgba(255, 255, 255, 0.470)',
    '--textLink': '#009ace',
    '--textError': '#d43f58',
    '--textWarning': '#fa8e41',
    '--textSuccess': '#00964e',
    '--iconPrimary': 'rgba(0, 0, 0, 0.930)',
    '--iconSecondary': 'rgba(0, 0, 0, 0.630)',
    '--iconTertiary': 'rgba(0, 0, 0, 0.445)',
    '--iconInverse': '#ffffff',
    '--iconOnColorPrimary': '#ffffff',
    '--iconOnColorSecondary': 'rgba(255, 255, 255, 0.772)',
    '--iconOnColorTertiary': 'rgba(255, 255, 255, 0.505)',
    '--iconLink': '#009ace',
    '--iconError': '#d43f58',
    '--iconWarning': '#fa8e41',
    '--iconSuccess': '#00964e',
    '--backgroundSubtleHover': 'rgba(0, 0, 0, 0.045)',
    '--backgroundAccentHover': '#d2d2d2',
    '--backgroundInteractiveHover': '#008ec2',
    '--backgroundDestructiveHover': '#c42d49',
    '--borderSubtleHover': 'rgba(0, 0, 0, 0.125)',
    '--borderAccentHover': 'rgba(0, 0, 0, 0.340)',
    '--backgroundSubtleActive': 'rgba(0, 0, 0, 0.085)',
    '--backgroundAccentActive': '#c5c5c5',
    '--backgroundInteractiveActive': '#0080b2',
    '--backgroundDestructiveActive': '#b51f3f',
    '--borderAccentActive': 'rgba(0, 0, 0, 0.495)',
    '--borderFocus': '#009ace',
    '--borderOnColorFocus': '#ffffff',
    '--backgroundInteractiveDisabled': 'rgba(0, 0, 0, 0.045)',
    '--backgroundDestructiveDisabled': 'rgba(0, 0, 0, 0.045)',
    '--borderDisabled': 'rgba(0, 0, 0, 0.085)',
    '--textDisabled': 'rgba(0, 0, 0, 0.125)',
    '--iconDisabled': 'rgba(0, 0, 0, 0.125)',
    '--backgroundMenu': '#ffffff',
    '--backgroundOverfill': '#ffffff',
    '--toggle': '#ffffff',
    '--toggleDisabled': 'rgba(0, 0, 0, 0.045)',

    '--notificationBackgroundSuccess': 'var(--green5)',
    '--notificationBorderSuccess': 'var(--green15)',
    '--notificationBackgroundInformation': 'var(--blue5)',
    '--notificationBorderInformation': 'var(--blue15)',
    '--notificationBackgroundWarning': 'var(--orange5)',
    '--notificationBorderWarning': 'var(--orange15)',
    '--notificationBackgroundError': 'var(--red5)',
    '--notificationBorderError': 'var(--red15)',
  },
  dark: {
    '--backgroundSubtle00': '#121212',
    '--backgroundSubtle01': '#1b1b1b',
    '--backgroundSubtle02': '#262626',
    '--backgroundAccent': '#474747',
    '--backgroundInverse': '#ffffff',
    '--backgroundInteractive': '#009ace',
    '--backgroundDestructive': '#d43f58',
    '--backgroundOverlay': 'rgba(0, 0, 0, 0.630)',
    '--borderSubtle': 'rgba(255, 255, 255, 0.085)',
    '--borderAccent': 'rgba(255, 255, 255, 0.230)',
    '--borderInteractive': '#41c1f0',
    '--borderError': '#fc8397',
    '--borderWarning': '#fa8e41',
    '--borderSuccess': '#4dbd78',
    '--textPrimary': '#ffffff',
    '--textSecondary': 'rgba(255, 255, 255, 0.772)',
    '--textTertiary': 'rgba(255, 255, 255, 0.470)',
    '--textInverse': 'rgba(0, 0, 0, 0.930)',
    '--textOnColorPrimary': '#ffffff',
    '--textOnColorSecondary': 'rgba(255, 255, 255, 0.772)',
    '--textOnColorTertiary': 'rgba(255, 255, 255, 0.470)',
    '--textLink': '#41c1f0',
    '--textError': '#fc8397',
    '--textWarning': '#fa8e41',
    '--textSuccess': '#4dbd78',
    '--iconPrimary': '#ffffff',
    '--iconSecondary': 'rgba(255, 255, 255, 0.757)',
    '--iconTertiary': 'rgba(255, 255, 255, 0.470)',
    '--iconsInverse': 'rgba(0, 0, 0, 0.930)',
    '--iconOnColorPrimary': '#ffffff',
    '--conOnColorSecondary': 'rgba(255, 255, 255, 0.757)',
    '--iconOnColorTertiary': 'rgba(255, 255, 255, 0.470)',
    '--iconLink': '#41c1f0',
    '--iconError': '#fc8397',
    '--iconWarning': '#fa8e41',
    '--iconSuccess': '#4dbd78',
    '--backgroundSubtleHover': 'rgba(255, 255, 255, 0.045)',
    '--backgroundAccentHover': '#525252',
    '--backgroundInteractiveHover': '#008ec2',
    '--backgroundDestructiveHover': '#c42d49',
    '--borderSubtleHover': 'rgba(255, 255, 255, 0.125)',
    '--borderAccentHover': 'rgba(255, 255, 255, 0.320)',
    '--backgroundSubtleActive': 'rgba(255, 255, 255, 0.085)',
    '--backgroundAccentActive': '#5e5e5e',
    '--backgroundInteractiveActive': '#0080b2',
    '--backgroundDestructiveActive': '#b51f3f',
    '--borderAccentActive': 'rgba(255, 255, 255, 0.410)',
    '--borderFocus': '#41c1f0',
    '--borderOnColorFocus': '#ffffff',
    '--backgroundInteractiveDisabled': 'rgba(255, 255, 255, 0.045)',
    '--backgroundDestructiveDisabled': 'rgba(255, 255, 255, 0.060)',
    '--borderDisabled': 'rgba(255, 255, 255, 0.085)',
    '--textDisabled': 'rgba(255, 255, 255, 0.172)',
    '--iconDisabled': 'rgba(255, 255, 255, 0.172)',
    '--backgroundMenu': '#262626',
    '--backgroundOverfill': 'rgba(255, 255, 255, 0.320)',
    '--toggle': '#ffffff',
    '--toggleDisabled': 'rgba(255, 255, 255, 0.045)',

    '--notificationBackgroundSuccess': 'var(--green95)',
    '--notificationBorderSuccess': 'var(--green85)',
    '--notificationBackgroundInformation': 'var(--blue95)',
    '--notificationBorderInformation': 'var(--blue85)',
    '--notificationBackgroundWarning': 'var(--orange95)',
    '--notificationBorderWarning': 'var(--orange85)',
    '--notificationBackgroundError': 'var(--red95)',
    '--notificationBorderError': 'var(--red85)',
  },
  spacing: {
    '--sp01': '4px',
    '--sp02': '8px',
    '--sp03': '12px',
    '--sp04': '16px',
    '--sp05': '24px',
    '--sp06': '32px',
    '--sp07': '40px',
    '--sp08': '48px',
    '--sp09': '56px',
    '--sp10': '64px',
    '--sp11': '80px',
    '--sp12': '96px',
  },
  breakpoints: {
    '--watch': '176px',
    '--mobile': '320px',
    '--tabletPortrait': '768px',
    '--tabletLandscape': '1024px',
    '--desktop': '1440px',
    '--tv': '1920px',
  },
  typography: {
    '--tpCode02': '400 14px/20px Roboto Mono, Arial, sans-serif',
    '--tpCode01': '400 12px/16px Roboto Mono, Arial, sans-serif',
    '--tpLabel01': '400 12px/16px Roboto, Arial, sans-serif',
    '--tpHeading01': '500 14px/20px Roboto, Arial, sans-serif',
    '--tpHeading02': '500 17px/24px Roboto, Arial, sans-serif',
    '--tpHeading03': '500 24px/32px Roboto, Arial, sans-serif',
    '--tpHeading04': '500 28px/36px Roboto, Arial, sans-serif',
    '--tpHeading05': '500 36px/44px Roboto, Arial, sans-serif',
    '--tpDisplay01Light': '300 44px/52px Roboto, Arial, sans-serif',
    '--tpDisplay01Bold': '500 44px/52px Roboto, Arial, sans-serif',
    '--tpDisplay02Light': '300 52px/60px Roboto, Arial, sans-serif',
    '--tpDisplay02Bold': '500 52px/60px Roboto, Arial, sans-serif',
    '--tpDisplay03Light': '300 72px/96px Roboto, Arial, sans-serif',
    '--tpDisplay03Bold': '500 72px/96px Roboto, Arial, sans-serif',
    '--tpDisplay04Light': '300 96px/116px Roboto, Arial, sans-serif',
    '--tpDisplay04Bold': '500 96px/116px Roboto, Arial, sans-serif',
    '--tpBody02': '400 17px/24px Roboto, Arial, sans-serif',
    '--tpBody01': '400 14px/20px Roboto, Arial, sans-serif',
  },
};
